import type * as lazyIndex from "./lazyIndex";
import { popoutMailReadingPane } from "owa-popout";
// Direct sub-path import — going through the package barrel pulls the full
// store index (adapters, services, selectors) into AppBoot. This file is
// eagerly evaluated at boot to register the orchestrator.
import { openDraftReplyFromBriefing } from "owa-personal-os-store/lib/actions/openDraftReplyFromBriefingAction";
import { reserveTodayInteraction } from "owa-personal-os-store/lib/utils/todayReloadInteraction";
import { orchestrator } from "satcheljs";
import { LazyModule, registerLazyOrchestrator, createLazyComponent, LazyAction, LazyImport, type LazyComponent, } from "owa-bundling";
import type { ProjectionReadingPaneProps } from "./components/ProjectionReadingPane";

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "PopoutMailReadingPane"*/ "./lazyIndex"), { name: "PopoutMailReadingPane" });

// Register lazy orchestrators
registerLazyOrchestrator(popoutMailReadingPane, lazyModule, m => m.popoutMailReadingPaneOrchestrator);
const lazyOpenDraftReply: LazyImport<typeof lazyIndex.openDraftReplyFromBriefingOrchestrator.handler, typeof lazyModule> = new LazyImport(lazyModule, m => m.openDraftReplyFromBriefingOrchestrator.handler);
orchestrator(openDraftReplyFromBriefing, async (message) => {
    // Acquire synchronously so the caller can release its reservation after dispatch.
    const releaseReload = reserveTodayInteraction();
    if (!releaseReload) {
        return;
    }
    try {
        const openDraftReply = await lazyOpenDraftReply.import();
        await openDraftReply(message);
    }
    finally {
        releaseReload();
    }
});

// Lazy components
export const ProjectionReadingPane: LazyComponent<ProjectionReadingPaneProps, unknown, void> = createLazyComponent(lazyModule, m => m.ProjectionReadingPane);
export const lazyPopoutMailReadingPaneUtil: LazyAction<typeof lazyIndex.popoutMailReadingPaneUtil, typeof lazyModule> = new LazyAction(lazyModule, m => m.popoutMailReadingPaneUtil);
export const lazyNavigateReadingPaneProjection: LazyImport<typeof lazyIndex.navigateReadingPaneProjection, typeof lazyModule> = new LazyImport(lazyModule, m => m.navigateReadingPaneProjection);
